/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import littlefoot from 'littlefoot'
import 'littlefoot/dist/littlefoot.css'

export function onRouteUpdate() {
  littlefoot({
    buttonTemplate: `
   <div class="littlefoot-footnote__container">
  <button
    aria-controls="fncontent:<%= id %>"
    aria-expanded="false"
    aria-label="Footnote <%= number %>"
    class="littlefoot-footnote__button littlefoot-footnote__button__ellipsis"
    data-footnote-button-id="<%= id %>"
    data-footnote-number="<%= number %>"
    id="<%= reference %>"
    rel="footnote"
    title="See Footnote <%= number %>"
  >
    <svg viewbox="0 0 9 6" preserveAspectRatio="xMidYMid">
      <circle r="3" cx="3" cy="3" fill="white"></circle>
    </svg>
  </button>
</div> `,
  }) // Pass any littlefoot settings here.
}
/*

<!-- Links -->
<p>
  <sup id="fnref:1">
    <a href="#fn:1" rel="footnote">1</a>
  </sup>
</p>

<!-- Footnote List -->
<div class="footnotes">
  <ol>
    <li class="footnote" id="fn:1">
      <p>footnote. <a href="#fnref:1" title="return to article"> ↩</a></p>
      <p></p>
    </li>
  </ol>
</div>
*/
